// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `opamain {
    padding: 16px;
    display: flex;
    flex-flow: column;
}

opaSettingsContainer {
	display: flex;
	flex-flow: column;
	margin-top: 36px;
}

opaSettingsHeader {
	display: flex;
	max-width: 800px;
	margin-bottom: 18px;
	flex-flow: column;
}

opaSettingsPartsContainer {
	display: flex;
	flex-flow: column;
}

opaSettingsCol {
	display: flex;
	flex-flow: column;
}

opaSettingsRow {
	display: flex;
	flex-flow: row;
}

opaItem * {
	width: 100%;
}

.opaSettingsInput {
	width: 300px;
	position: relative;
	display: inline-flex;
	align-items: center;
}

.opaSettingsInput input {
	padding-right: 18px;
	box-sizing: border-box;
}

.opaSettingsInput deleteIcon {
	position: absolute;
	display: block;
	right: 10px;
	width: 15px;
	height: 15px;
	border-radius: 50%;
	color: var(--color-text-maxcontrast);
	background-color: var(--color-background-dark);
	font: 13px monospace;
	text-align: center;
	line-height: 1em;
	cursor: pointer;
}

.yesNo span.checkbox-content__text.checkbox-radio-switch__text {
	width: 50px !important;
	justify-content: center;
	text-wrap: nowrap;
}

.withSimpleBottomMargin {
	margin-bottom: 4px;
}

.withDoubleBottomMargin {
	margin-bottom: 8px;
}

.opaSettingsLabel {
	min-width: 200px;
}

.opaSettingsImage {
	align-items: center;
	display: flex;
	justify-content: center;
}

.opaClickable {
	cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/opaSettings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,iBAAiB;AACrB;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,oCAAoC;CACpC,8CAA8C;CAC9C,oBAAoB;CACpB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,eAAe;AAChB","sourcesContent":["opamain {\r\n    padding: 16px;\r\n    display: flex;\r\n    flex-flow: column;\r\n}\r\n\r\nopaSettingsContainer {\r\n\tdisplay: flex;\r\n\tflex-flow: column;\r\n\tmargin-top: 36px;\r\n}\r\n\r\nopaSettingsHeader {\r\n\tdisplay: flex;\r\n\tmax-width: 800px;\r\n\tmargin-bottom: 18px;\r\n\tflex-flow: column;\r\n}\r\n\r\nopaSettingsPartsContainer {\r\n\tdisplay: flex;\r\n\tflex-flow: column;\r\n}\r\n\r\nopaSettingsCol {\r\n\tdisplay: flex;\r\n\tflex-flow: column;\r\n}\r\n\r\nopaSettingsRow {\r\n\tdisplay: flex;\r\n\tflex-flow: row;\r\n}\r\n\r\nopaItem * {\r\n\twidth: 100%;\r\n}\r\n\r\n.opaSettingsInput {\r\n\twidth: 300px;\r\n\tposition: relative;\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n}\r\n\r\n.opaSettingsInput input {\r\n\tpadding-right: 18px;\r\n\tbox-sizing: border-box;\r\n}\r\n\r\n.opaSettingsInput deleteIcon {\r\n\tposition: absolute;\r\n\tdisplay: block;\r\n\tright: 10px;\r\n\twidth: 15px;\r\n\theight: 15px;\r\n\tborder-radius: 50%;\r\n\tcolor: var(--color-text-maxcontrast);\r\n\tbackground-color: var(--color-background-dark);\r\n\tfont: 13px monospace;\r\n\ttext-align: center;\r\n\tline-height: 1em;\r\n\tcursor: pointer;\r\n}\r\n\r\n.yesNo span.checkbox-content__text.checkbox-radio-switch__text {\r\n\twidth: 50px !important;\r\n\tjustify-content: center;\r\n\ttext-wrap: nowrap;\r\n}\r\n\r\n.withSimpleBottomMargin {\r\n\tmargin-bottom: 4px;\r\n}\r\n\r\n.withDoubleBottomMargin {\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.opaSettingsLabel {\r\n\tmin-width: 200px;\r\n}\r\n\r\n.opaSettingsImage {\r\n\talign-items: center;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n}\r\n\r\n.opaClickable {\r\n\tcursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
